/** Shared selection for Fervi's product and cart presentation (not order validation). */
export function getFerviAvailability<T extends { sellable?: boolean }>(
  availability: T | null | undefined,
  unavailability: T | null | undefined,
  stock: number,
  requestedQuantity: number,
): T | null {
  return (
    (stock >= requestedQuantity || availability?.sellable ? availability : unavailability) ?? null
  );
}

export function getDeliveryDays(value: unknown): number | null {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  const days = Number(value);
  return Number.isFinite(days) && Number.isInteger(days) && days > 0 ? days : null;
}
